import StartEventHook from './StartEventHook'
import Logger from '../Log'
import { bidderForCode } from '../utils'

const Log = Logger.for('AppnexusHook')

export default class AppnexusStartHook extends StartEventHook {
  constructor () {
    super('AppnexusHook')
  }

  async run (remoteConfig, pbjs) {
    pbjs.aliasBidder('appnexus', 'appnexus_banner')

    let bidder = bidderForCode('appnexus_video', remoteConfig.bidders())
    if (bidder) {
      pbjs.aliasBidder('appnexus', 'appnexus_video')

      const v = remoteConfig.media().video
      if (v) {
        bidder.params.video = {
          playback_method: ['auto_play_sound_off'],
          mimes: ['video/mp4'],
          minduration: 0,
          maxduration: 30,
          skippable: false,
          frameworks: v.apis
        }

        Log.debug('Injected video settings into appnexus bidder')
      }
    }

    bidder = bidderForCode('appnexus_native', remoteConfig.bidders())
    if (bidder) {
      pbjs.aliasBidder('appnexus', 'appnexus_native')

      if (!remoteConfig.media().native) {
        Log.debug('Temp injecting native config for Appnexus')
        remoteConfig.media().native = {
          type: 'image'
        }
      }
    }
  }
}
